import { getInitialStateFromConfig } from "helpers/form";
import { list } from "sources/books/trailers";
import components from "./components";

const config = {
    trailerId: {
        // async-select
        label: "Прицеп",
        inputProps: { name: "trailerOption" },
        url: list,
        propName: "number",
        components: components.trailer,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
